import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ProductManager from '@/components/v2/inquiry/ProductManager.vue';
import CardItem from '@/components/v2/CardItem.vue';
import SearchMixinProp from '@/helpers/vue_mixins/v2/SearchMixinProp';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CopierDialog from '@/components/v2/CopierDialog.vue';
import CopierMixin from '@/helpers/vue_mixins/v2/CopierMixin';
/**
 * Inquiry Product Grid View
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.18}
 */
let ProductGridView = class ProductGridView extends Mixins(RouterParamsAppMixin, SearchMixinProp, AlertMixin, CopierMixin) {
};
ProductGridView = __decorate([
    Component({
        components: {
            ProductManager,
            CardItem,
            CopierDialog,
        },
    })
], ProductGridView);
export default ProductGridView;
